/**
 * Sentry browser error tracking — initialised once at app boot.
 *
 * Active only when NODE_ENV === "production" so dev runs stay silent.
 * The DSN is a public ingest credential; it is safe to embed in the bundle.
 */
import * as Sentry from "@sentry/react";

export const isProduction = process.env.NODE_ENV === "production";

const dsn = process.env.REACT_APP_SENTRY_DSN;

if (isProduction && dsn) {
  Sentry.init({
    dsn,
    environment: "production",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    // Hard gate: even if `enabled` were toggled, never report from dev.
    beforeSend(event) {
      return isProduction ? event : null;
    },
    // Drop noisy known browser extensions / pre-render errors.
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "Non-Error promise rejection captured",
    ],
  });
}

export { Sentry };
